import { themeVars } from '@coverflex-tech/hypernova';
import { keyframes, style } from '@vanilla-extract/css';

const slideIn = keyframes({
  from: {
    transform: 'translateY(100%)',
  },
  to: {
    transform: 'translateY(0)',
  },
});

const root = style({
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%',
  padding: themeVars.spacing.lg,
  animation: `${slideIn} 0.3s ease-out`,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
});

const description = style({
  textAlign: 'center',
  margin: '0 auto',
  maxWidth: '50rem',
});

const actions = style({
  display: 'flex',
  marginTop: themeVars.spacing.lg,
  gap: themeVars.spacing.md,
  justifyContent: 'center',
});

const badge = style({
  maxHeight: '4.2rem',
});

export const css = {
  root,
  description,
  actions,
  badge,
};
